import { render, staticRenderFns } from "./teacherRecord.vue?vue&type=template&id=2a8f586a&scoped=true&"
import script from "./teacherRecord.vue?vue&type=script&lang=js&"
export * from "./teacherRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8f586a",
  null
  
)

export default component.exports